import { IconConstants } from 'cc-common';
import * as i0 from "@angular/core";
export class FileHelperService {
    getFileType(file) {
        let fileType;
        if (file.type === 'pdf') {
            fileType = IconConstants.PDF_FILE;
        }
        else if (file.type === 'doc' || file.type === 'docx') {
            fileType = IconConstants.DOCS;
        }
        else if (file.type === 'xlsx') {
            fileType = IconConstants.XLSX;
        }
        else if (file.type === 'pptx') {
            fileType = IconConstants.PPTX;
        }
        else if (file.type === 'png') {
            fileType = IconConstants.PNG;
        }
        else if (file.type === 'jpg' || file.type === 'jpeg') {
            fileType = IconConstants.JPEG;
        }
        else if (file.type === 'gif') {
            fileType = IconConstants.GIF;
        }
        else if (file.type === 'txt') {
            fileType = IconConstants.TEXT;
        }
        return fileType;
    }
    getFileIcon(fileName) {
        let fileType;
        if (fileName.includes('.pdf')) {
            fileType = IconConstants.PDF_FILE_GRID;
        }
        else if (fileName.includes('.doc') || fileName.includes('.docx')) {
            fileType = IconConstants.DOCS;
        }
        else if (fileName.includes('.xlsx')) {
            fileType = IconConstants.XLSX;
        }
        else if (fileName.includes('.pptx')) {
            fileType = IconConstants.PPTX;
        }
        else if (fileName.includes('.png')) {
            fileType = IconConstants.PNG;
        }
        else if (fileName.includes('.jpg') || fileName.includes('.jpeg')) {
            fileType = IconConstants.JPEG;
        }
        else if (fileName.includes('.gif')) {
            fileType = IconConstants.GIF;
        }
        else if (fileName.includes('.txt')) {
            fileType = IconConstants.TEXT;
        }
        return fileType;
    }
}
FileHelperService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FileHelperService_Factory() { return new FileHelperService(); }, token: FileHelperService, providedIn: "root" });
